import {gql} from "@apollo/client";

const CORE_ACTION_PHASE_FIELDS = gql`
  fragment CoreActionPhaseSchemaFields on ActionPhase {
    id
    name
    description
    ordering
    backgroundColor
    foregroundColor
    isDeleted
  }
`;

export const GET_ACTION_PHASES = gql`
  ${CORE_ACTION_PHASE_FIELDS}
  query GetActionPhases {
    actionPhases(orderBy: {ordering: asc}) {
      ...CoreActionPhaseSchemaFields
      inUseBy {
        model
        count
      }
    }
  }
`;

export const CREATE_ACTION_PHASE = gql`
  ${CORE_ACTION_PHASE_FIELDS}
  mutation CreateActionPhase(
    $name: String!
    $description: String
    $ordering: Int
    $backgroundColor: String
    $foregroundColor: String
  ) {
    createOneActionPhase(
      data: {
        name: $name
        description: $description
        ordering: $ordering
        backgroundColor: $backgroundColor
        foregroundColor: $foregroundColor
      }
    ) {
      ...CoreActionPhaseSchemaFields
    }
  }
`;

export const UPDATE_ACTION_PHASE = gql`
  ${CORE_ACTION_PHASE_FIELDS}
  mutation UpdateActionPhase(
    $id: Int!
    $name: String!
    $description: String
    $backgroundColor: String
    $foregroundColor: String
  ) {
    updateOneActionPhase(
      where: {id: $id}
      data: {
        name: {set: $name}
        description: {set: $description}
        backgroundColor: {set: $backgroundColor}
        foregroundColor: {set: $foregroundColor}
      }
    ) {
      ...CoreActionPhaseSchemaFields
    }
  }
`;

export const SOFT_DELETE_ACTION_PHASE = gql`
  ${CORE_ACTION_PHASE_FIELDS}
  mutation SoftDeleteActionPhase($id: Int!) {
    deleteOneActionPhase(where: {id: $id}) {
      ...CoreActionPhaseSchemaFields
    }
  }
`;

export const DECREMENT_ACTION_PHASES = gql`
  mutation DecrementActionPhases($ordering: Int!) {
    updateManyActionPhase(where: {ordering: {gt: $ordering}}, data: {ordering: {decrement: 1}}) {
      count
      __typename
    }
  }
`;
